module.exports = __webpack_public_path__ + "img/ocr.cb6bf335.png";